'use client';

import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import { Button, Card, CardContent, Grid } from '@mui/material';
import { Stack } from '@mui/system';

import { CustomConfigInputProps, InputType } from '@/types/general';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';
import { LanguageSelector } from '@/components/core/language-selector';

import { GameDetailsTable } from '../game-details-table';

export function GameDetails({ game }: { game: any | undefined }): React.JSX.Element {
  const searchParams = useSearchParams();
  const selectedLanguage = searchParams.get('selectedLanguage') || 'en';

  // const { GENERAL_GAME_DETAILS: data } = useAppSelector(getDrawerContent);

  const [dto, setDto] = React.useState({
    title: game?.title[selectedLanguage] || '',
    description: game?.desc[selectedLanguage] || '',
    rtp: game?.rtp,
  });

  const inputs: CustomConfigInputProps[] = [
    {
      label: 'Title',
      name: 'title',
      value: dto.title,
      type: InputType.INPUT,
      size: { xs: 12, lg: 6 },
    },
    {
      label: 'Display RTP',
      name: 'rtp',
      value: dto.rtp,
      type: InputType.INPUT,
      size: { xs: 12, lg: 6 },
    },
    {
      label: 'Description',
      name: 'description',
      value: dto.description,
      type: InputType.MULTILINE_INPUT,
      size: { xs: 12 },
    },
  ];

  return (
    <Stack direction="column" gap={2}>
      <Card>
        <CardContent>
          <Stack direction="column" gap={1.5}>
            {game ? <GameDetailsTable gameData={{ ...game }} /> : null}
          </Stack>
        </CardContent>
      </Card>
      <LanguageSelector />

      <Stack direction="row" gap={2}>
        <Card sx={{ width: 1 }}>
          <CardContent>
            <Stack direction="column" gap={1.5}>
              {/* <Image src={}/> */}
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ width: 1 }}>
          <CardContent>
            <Stack direction="column" gap={1.5}>
              {/* <Image src={}/> */}
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <Grid container spacing={2}>
        {inputs.map((item, index) => (
          <CustomConfigInputV2 key={index} {...item} defaultData={dto} setDefaultData={setDto} />
        ))}
      </Grid>

      <Stack direction="row" justifyContent="end" gap={2}>
        <Button type="submit" variant="contained" color="info">
          Save as Draft
        </Button>
        <Button type="submit" variant="contained">
          Publish
        </Button>
      </Stack>
    </Stack>
  );
}
